import $ from "jquery";
import 'jquery-validation';


$(document).ready(function () {

    // this code applies to the login/forgot password/recover password pages
    if ($('.template-login').length === 0) {
        return;
    }

    const validator = $('#login-form').validate({
        rules: {
            username: {
                required: true,
            },
            password: {
                required: true,
            }
        },
        messages: {
            username: {
                required: pgettext('field error', 'Please enter your username')
            },
            password: {
                required: pgettext('field error', 'Please enter your password')
            }
        }
    });

    //Check if fields are valid and add red border if not 
    $('body').on('click', '.login-btn', function () {
        const is_username_valid = validator.element('#username-field');
        const is_password_valid = validator.element('#password-field');

        if (!is_username_valid) {
            $('#username-field').addClass('error');
        } else {
            $('#username-field').removeClass('error');
        }
        if (!is_password_valid) {
            $('#password-field').addClass('error');
        } else {
            $('#password-field').removeClass('error');
        }
    });

    //Close dialog box error
    $('body').on('click', '.bi-x', function () {
        $('.alert-danger').addClass('d-none');
    });

    // toggle the password eye icon to show the password
    $('body').on('click', '.toggle-password', function () {
        $(this).toggleClass("bi-eye bi-eye-slash");
        const input = $($(this).attr("toggle"));
        if (input.attr("type") === "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    });

    // get the timezone from the user's locale
    $("#timezone").val(Intl.DateTimeFormat().resolvedOptions().timeZone);

    ///Read More buttons to show more text
    $(document).ready(function() {
        $("#read-more-btn-col-one").click(function() {
          $("#text-hide-col-one").toggle();
        });
        $("#read-more-btn-col-two").click(function() {
          $("#text-hide-col-two").toggle();
        });
      });

});

   ///review carousel////

document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.pages-wrapper');
  const dotsWrapper = document.querySelector('.dots-wrapper');
  const prevBtn = document.querySelector('.left-btn');
  const nextBtn = document.querySelector('.right-btn');

  let currentPage = 0;
  let isAnimating = false;
  let currentMode = window.innerWidth < 768 ? 'mobile' : 'desktop';

  // Grab original review elements from hidden block
  const originalReviews = Array.from(document.querySelectorAll('.s6-original-reviews .review')).map(el => el.cloneNode(true));

  function isMobileView() {
    return window.innerWidth < 768;
  }

  function restructurePages() {
    wrapper.innerHTML = '';

    if (isMobileView()) {
      originalReviews.forEach(review => {
        const page = document.createElement('div');
        page.classList.add('page');
        page.appendChild(review.cloneNode(true));
        wrapper.appendChild(page);
      });
    } else {
      for (let i = 0; i < originalReviews.length; i += 2) {
        const page = document.createElement('div');
        page.classList.add('s6-container-flex', 'page');
        page.appendChild(originalReviews[i].cloneNode(true));
        if (originalReviews[i + 1]) {
          page.appendChild(originalReviews[i + 1].cloneNode(true));
        }
        wrapper.appendChild(page);
      }
    }
  }

  function setupCarousel() {
    wrapper.innerHTML = '';
    dotsWrapper.innerHTML = '';

    restructurePages();

    let pages = Array.from(wrapper.querySelectorAll('.page'));
    const totalPages = pages.length;

    if (totalPages === 0) return;

    const firstClone = pages[0].cloneNode(true);
    const lastClone = pages[pages.length - 1].cloneNode(true);
    firstClone.classList.add('clone');
    lastClone.classList.add('clone');
    wrapper.appendChild(firstClone);
    wrapper.insertBefore(lastClone, wrapper.firstChild);

    currentPage = 0;
    wrapper.style.transition = 'none';
    wrapper.style.transform = `translateX(-100%)`;

    buildDots(totalPages);

    nextBtn.onclick = () => handleNext(totalPages);
    prevBtn.onclick = () => handlePrev(totalPages);

    enableSwipe(totalPages);

    wrapper.addEventListener("transitionend", () => {
      isAnimating = false;
    });
  }

  function buildDots(count) {
    for (let i = 0; i < count; i++) {
      const dot = document.createElement('button');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        if (!isAnimating && currentPage !== i) {
          goToPage(i);
        }
      });
      dotsWrapper.appendChild(dot);
    }
  }

  function updateDots() {
    const dots = Array.from(dotsWrapper.children);
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === currentPage);
    });
  }

  function goToPage(target) {
    isAnimating = true;
    currentPage = target;
    wrapper.style.transition = "transform 0.5s ease";
    wrapper.style.transform = `translateX(-${(currentPage + 1) * 100}%)`;
    updateDots();
  }

  function handleNext(totalPages) {
    if (isAnimating) return;

    if (currentPage >= totalPages - 1) {
      isAnimating = true;
      wrapper.style.transition = "transform 0.5s ease";
      wrapper.style.transform = `translateX(-${(totalPages + 1) * 100}%)`;
      currentPage = 0;
      updateDots();
      setTimeout(() => {
        wrapper.style.transition = "none";
        wrapper.style.transform = `translateX(-100%)`;
        isAnimating = false;
      }, 500);
    } else {
      goToPage(currentPage + 1);
    }
  }

  function handlePrev(totalPages) {
    if (isAnimating) return;

    if (currentPage <= 0) {
      isAnimating = true;
      wrapper.style.transition = "transform 0.5s ease";
      wrapper.style.transform = `translateX(0%)`;
      currentPage = totalPages - 1;
      updateDots();
      setTimeout(() => {
        wrapper.style.transition = "none";
        wrapper.style.transform = `translateX(-${totalPages * 100}%)`;
        isAnimating = false;
      }, 500);
    } else {
      goToPage(currentPage - 1);
    }
  }

  function enableSwipe(totalPages) {
    let startX = 0;
    wrapper.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
    });
    wrapper.addEventListener('touchend', e => {
      if (isAnimating) return;
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) handleNext(totalPages);
        else handlePrev(totalPages);
      }
    });
  }

  window.addEventListener('resize', () => {
    const newMode = isMobileView() ? 'mobile' : 'desktop';
    if (newMode !== currentMode) {
      currentMode = newMode;
      setupCarousel();
    }
  });


    // only run this on the homepage
    if(document.querySelectorAll('.homepage').length >= 1) {
        setupCarousel();
    }
});

